import { render, staticRenderFns } from "./dataStatisticsGeneral.vue?vue&type=template&id=ba6f4f50&scoped=true"
import script from "./dataStatisticsGeneral.vue?vue&type=script&lang=js"
export * from "./dataStatisticsGeneral.vue?vue&type=script&lang=js"
import style0 from "./dataStatisticsGeneral.vue?vue&type=style&index=0&id=ba6f4f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f4f50",
  null
  
)

export default component.exports